<template>
  <div>
    <b-button class="m-2" variant="primary" @click="newUserEmptyForm">Nový uživatel</b-button>
    <hr>
    <b-table striped hover :items="tableData" @row-clicked="rowClicked"></b-table>

    <b-modal id="userEditModal" :title="modalTitle">
      <b-form-group label="E-mail:" label-for="inputEmail">
        <b-form-input v-model="user.email" id="inputEmail" type="text" size="sm" required/>
      </b-form-group>
      <b-form-group label="Heslo:" label-for="inputNewPasswordEdit">
        <b-form-input
          v-model="user.password"
          id="inputNewPasswordEdit"
          type="password"
          size="sm"
          required
        />
      </b-form-group>
      <b-form-group label="potvrzení hesla:" label-for="inputNewPasswordConfirm">
        <b-form-input
          v-model="user.passwordConfirm"
          id="inputNewPasswordConfirm"
          type="password"
          size="sm"
          required
        />
      </b-form-group>
      <b-form-checkbox class="big-checkbox" v-model="user.admin" switch>Admin</b-form-checkbox>

      <template slot="modal-footer">
        <b-button v-if="!newUserState" size="sm" variant="danger" @click="deleteUser()">Smazat</b-button>
        <b-button v-if="!newUserState" size="sm" variant="success" @click="updateUser()">Uložit</b-button>
        <b-button v-if="newUserState" size="sm" variant="success" @click="newUser()">Uložit(New)</b-button>
        <b-button size="sm" variant="primary" @click="$bvModal.hide('userEditModal')">Zrušit</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  data: () => ({
    tableData: [],
    selectedUser: null,
    modalTitle: null,
    newUserState: false, // nastavenie modalu na Novy pripadne Edit
    user: {
      email: '',
      password: null,
      passwordConfirm: null,
      admin: false
    }
  }),
  mounted () {
    this.getUsers()
  },
  methods: {
    getUsers () {
      axios
        .get('/api/v1/admin/user')
        .then(response => {
          this.tableData = response.data
        })
        .catch(err => {
          alert('errorLoadUsers' + err)
        })
    },
    rowClicked (item) {
      this.newUserState = false
      this.selectedUser = item.email
      this.modalTitle = 'Editace Uživatele: ' + this.selectedUser
      this.user.email = item.email
      this.user.admin = item.admin
      this.user.password = null
      this.user.passwordConfirm = null
      this.$bvModal.show('userEditModal')
    },
    newUserEmptyForm () {
      this.modalTitle = 'Nový Uživatel:'
      this.newUserState = true
      var defaultData = this.$options.data
      this.user = defaultData.call(this.user) // Reassign default values
      this.$bvModal.show('userEditModal')
    },
    newUser () {
      if (this.user.password === this.user.passwordConfirm) {
        axios
          .post('/api/v1/admin/user', this.user)
          .then(response => {
            this.getUsers()
            this.$bvModal.hide('userEditModal')
          })
          .catch(err => {
            alert('error Update user: ' + err)
            this.$bvModal.hide('userEditModal')
          })
      } else {
        this.$bvToast.toast(`heslo a potvrzeni hesla se neshodují`, {
          title: 'CHYBA!!!',
          variant: 'danger',
          autoHideDelay: 2000
        })
      }
    },
    updateUser () {
      axios
        .put(`/api/v1/admin/user/${this.selectedUser}`, this.user)
        .then(response => {
          this.getUsers()
          this.$bvModal.hide('userEditModal')
          this.$bvToast.toast(`Změny byli uložené`, {
            title: 'Uloženo',
            variant: 'success',
            autoHideDelay: 1500
          })
        })
        .catch(err => {
          alert('error Update user: ' + err)
          this.$bvModal.hide('userEditModal')
        })
    },
    deleteUser () {
      axios
        .delete(`/api/v1/admin/user/${this.selectedUser}`)
        .then(response => {
          this.$bvModal.hide('userEditModal')
          this.getUsers()
        })
        .catch(err => {
          alert('error Update user: ' + err)
          this.$bvModal.hide('userEditModal')
        })
    }
  }
})

</script>
